<template>
    <div class="section-box">
        <el-tabs v-model="tabType" type="card" class="customer-tabs-mg" :before-leave="tabSelect">
            <el-tab-pane v-for="(item, index) in tabArr" :label="item.value" :name="item.key + ''" :key="index">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button">
                <el-button size="small" type="primary" @click="getautoExamEngineerInfoList()">查询</el-button>
                <el-button size="small" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
                <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
            </div>
        </div>

        <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="590" border
            v-loading="listLoading">
            v-loading="listLoading">
               <el-table-column label="Id" >
                <el-table-column show-overflow-tooltip width="80">
                    <template slot="header" slot-scope="scope">
                        <!-- <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索"/> -->
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.Id || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="姓名">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.TrueName || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="手机号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.handset" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.Handset || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="证书名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.certificateName" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.CertificateName || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="报名时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.applyTime" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 100%"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.PaySuccessTimeStr || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="金额">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope"> </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.PayAmount || "0" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
             <el-table-column label="支付状态">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                         <el-select size="mini" v-model.trim="form.payStatus" placeholder="请选择" style="width: 100%;"  @change="getautoExamEngineerInfoList()">
                            <el-option :value="0" label="全部"></el-option>
                            <el-option :value="1" label="已支付"></el-option>
                            <el-option :value="2" label="未支付"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ (scope.row.PayStatus ? "已支付" : "未支付" ) }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
         
        </el-table>
        <div style="margin: 10px; overflow: hidden">
            <div style="float: right" v-show="tableData.length">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script>
import {
    getAutoEngineerApplyList
} from "@/service/examination.js";
import { getStorageAdminUser } from '@/utils/store'
export default {
    components: {},
    data() {
        return {
            userInfo: getStorageAdminUser(),
            tabType: '2',
            tabArr: [{
                key: 1,
                value: "数字化工程师",
            }, {
                key: 2,
                value: "报名页",
            }],
            listLoading: false,
            form: {
                pageNum: 1,
                pageSize: 10,
                certificateName: "",
                userName: "",
                handset: "",
                applyTime: [],
            },
            searchData: {},
            total: 0,

            tableData: [],
            detail: {},
            dialogVisible: false
        };
    },
    created() {
        this.tableData = [];
        this.getautoExamEngineerInfoList();
    },
    methods: {
        resetSearch() {
            this.form = {
                pageNum: 1,
                pageSize: 10,
                certificateName: "",
                userName: "",
                handset: "",
                applyTime: [],
                payAmount: '',   //支付金额结束
                payStatus:0, //支付状态
            }
            this.getautoExamEngineerInfoList();
        },
        downloadFile() {
            var data = {};
            var data = {
                PageNum: 0,
                PageSize: 0,
            };
            if (
                this.form.applyTime instanceof Array &&
                this.form.applyTime.length > 0
            ) {
                data.StartSignTime = this.form.applyTime[0];
                data.EndSignTime = this.form.applyTime[1];
            } else {
                if (data.StartSignTime) delete data.StartSignTime;
                if (data.EndSignTime) delete data.EndSignTime;
            }

            if (this.form.userName) data.TrueName = this.form.userName;
            if (this.form.handset) data.Handset = this.form.handset;
            if (this.form.certificateName) data.CertificateName = this.form.certificateName;
            if (this.form.payStatus) {
                data.PayStatus = this.form.payStatus;
            }

            let str = '';
            //拼接参数字符串
            for (const k in data) {
                if (Object.hasOwnProperty.call(data, k)) {
                    str += `${k}=${data[k]}&`
                }
            }
            // let url =
            // process.env.NODE_ENV == "development" ?
            // "/api2" :
            // process.env.VUE_APP_API4;

            let url =
            process.env.NODE_ENV == "development" ?
            "/api4" :
            process.env.VUE_APP_API4;
           
            window.open(url+`/api/AutoEngineerApply/DownAutoEngineerApply?${str}` );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                    if (json[key] === undefined) return "";
                    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                })
            ).join("&");
        },
        cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        },
        async getautoExamEngineerInfoList() {
            this.listLoading = true;
            var data = {
                PageNum: 1,
                PageSize: 10,
            };
            if (
                this.form.applyTime instanceof Array &&
                this.form.applyTime.length > 0
            ) {
                data.StartSignTime = this.form.applyTime[0];
                data.EndSignTime = this.form.applyTime[1];
            } else {
                if (data.StartSignTime) delete data.StartSignTime;
                if (data.EndSignTime) delete data.EndSignTime;
            }

            if (this.form.userName) data.TrueName = this.form.userName;
            if (this.form.handset) data.Handset = this.form.handset;
            if (this.form.certificateName) data.CertificateName = this.form.certificateName;
            if (this.form.payStatus) {
                data.PayStatus = this.form.payStatus;
            }

            data.PageNum = this.form.pageNum;
            data.PageSize = this.form.pageSize;

            console.log("请求参数：", JSON.stringify(data));
            let res = await getAutoEngineerApplyList(data);
            this.listLoading = false;
            if (res.Result != 1) {
                return this.$message.error("获取失败请联系开发人员");
            }
            this.tableData = res.Data.ApplyList;
            this.total = res.Data.TotalCount;
            
        },

        handleSizeChange(val) {
            if (this.listLoading) return;
            this.form.pageNum = 1;
            this.form.pageSize = val;
            this.getautoExamEngineerInfoList();
        },
        handleCurrentChange(val) {

            if (this.listLoading) return;
            this.form.pageNum = val;

            this.getautoExamEngineerInfoList();
        },
      
        //切换tab之前
        tabSelect(activeName, oldActiveName) {
            console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);

            if (activeName == "1") {
                this.$router.push('autoExamEngineer');
                return false;
            }
        }

    },
};
</script>
<style lang="scss">
.customer-tabs-mg {
    .el-tabs__header {
        margin: 0 0 15px !important;
    }
}

.customer-list {
    position: relative;

    .next-button {
        position: absolute;
        right: 0;
        top: -56px;
    }
}

.customer-row-bg {
    padding: 20px 14px;
    background-color: #f9fafc;
    display: flex;
    align-items: center;

    .el-form-item {
        margin-bottom: 0 !important;
    }

    .selected {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
}

.linkInfo {
    cursor: pointer;

    &:hover {
        color: #409eff;
    }
}

.dialog-info {
    .el-image {
        width: 200px;
        height: 200px;
        margin-right: 40px;
        margin-bottom: 1em;
        margin-top: 1em;
    }

    .address {
        border: 1px solid #E4E7ED;
        color: #666;
        padding: 5px 15px;
        line-height: 1.5;
        box-sizing: border-box;
        min-height: 100px;
        border-radius: 5px;
    }
}
</style>